import { MapPoints } from 'types/mapTypes';
// Google maps styles generated from https://mapstyle.withgoogle.com/

const mapStyles: google.maps.MapTypeStyle[] = [
  { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
  { elementType: MapPoints.LABELS_ICON, stylers: [{ visibility: 'off' }] },
  { elementType: MapPoints.LABELS_TEXTFILL, stylers: [{ color: '#616161' }] },
  {
    elementType: MapPoints.LABELS_TEXTSTROKE,
    stylers: [{ color: '#f5f5f5' }],
  },
  {
    featureType: MapPoints.ADMINISTRATIVE_LANDPARCEL,
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: MapPoints.ADMINISTRATIVE_LANDPARCEL,
    elementType: MapPoints.LABELS_TEXTFILL,
    stylers: [{ color: '#bdbdbd' }],
  },
  {
    featureType: MapPoints.ADMINISTRATIVE_NEIGHBORHOOD,
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [{ color: '#eeeeee' }],
  },
  {
    featureType: 'poi',
    elementType: MapPoints.LABELS_TEXTFILL,
    stylers: [{ color: '#757575' }],
  },
  {
    featureType: MapPoints.POI_PARK,
    elementType: 'geometry',
    stylers: [{ color: '#e5e5e5' }],
  },
  {
    featureType: MapPoints.POI_PARK,
    elementType: MapPoints.LABELS_TEXTFILL,
    stylers: [{ color: '#9e9e9e' }],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{ color: '#ffffff' }],
  },
  {
    featureType: 'road',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: MapPoints.ROAD_ARTERIAL,
    elementType: MapPoints.LABELS_TEXTFILL,
    stylers: [{ color: '#757575' }],
  },
  {
    featureType: MapPoints.ROAD_HIGHWAY,
    elementType: 'geometry',
    stylers: [{ color: '#dadada' }],
  },
  {
    featureType: MapPoints.ROAD_HIGHWAY,
    elementType: MapPoints.LABELS_TEXTFILL,
    stylers: [{ color: '#616161' }],
  },
  {
    featureType: MapPoints.ROAD_LOCAL,
    elementType: MapPoints.LABELS_TEXTFILL,
    stylers: [{ color: '#9e9e9e' }],
  },
  {
    featureType: MapPoints.TRANSIT_LINE,
    elementType: 'geometry',
    stylers: [{ color: '#e5e5e5' }],
  },
  {
    featureType: MapPoints.TRANSIT_STATION,
    elementType: 'geometry',
    stylers: [{ color: '#eeeeee' }],
  },
  {
    featureType: MapPoints.WATER,
    elementType: 'geometry',
    stylers: [{ color: '#aadaff' }],
  },
  {
    featureType: MapPoints.WATER,
    elementType: MapPoints.LABELS_TEXT,
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: MapPoints.WATER,
    elementType: MapPoints.LABELS_TEXTFILL,
    stylers: [{ color: '#9e9e9e' }],
  },
];

export default mapStyles;
